import React, { useState, useEffect } from "react";
import { MdPhoneAndroid } from "react-icons/md";
import { MdEmail } from "react-icons/md";
import { FaAddressBook } from "react-icons/fa";
import { FaAddressCard } from "react-icons/fa";
import { Tag } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { components, getRowClassName } from "../../utils/utils";
import {
  Col,
  message,
  Popconfirm,
  Row,
  Space,
  Switch,
  Form,
  Table,
  Tooltip,
  Tabs,
  navigate,
  Input,
  Button,
} from "antd";
import IMAGES from "../../const/Image";
import SalonRequest from "./SalonRequest";
import dayjs from "dayjs";
import { useNavigate, useLocation, useParams } from "react-router-dom";
// import Slider from "react-slick";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const confirm = (e) => {
  console.log(e);
  message.success("Deleted!");
};

const onChange = (key) => {
  console.log(key);
};

export const Categories = () => {
  const initialFilter = { page: 1, limit: 10 };
  const [filter, setFilter] = useState(initialFilter);
  const [loading, setLoading] = useState(false);
  const { salonId, id } = useParams();

  const [totalRecords, setTotalRecords] = useState(0);
  const [salonCategories, setSalonCategories] = useState([]);
  const [categoryServices, setCategoryServices] = useState([]);
  const [activeVisitType, setActiveVisitType] = useState("home");
  const [activeGenderTab, setActiveGenderTab] = useState("male");
  const navigate = useNavigate();

  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  console.log("id", id);
  console.log("salonId", salonId);




  // Update selected category when visit type changes
  // Update selected category when visit type changes
  const handleVisitTypeChange = (visitTypeKey) => {
    setActiveVisitType(visitTypeKey);
    
    const filteredCategories = salonCategories.filter((category) => {
      if (visitTypeKey === "home") return category.visitType === 0;
      if (visitTypeKey === "salon") return category.visitType === 1;
      return category.visitType === 2;
    });

    // Find first male category by default
    const firstMaleCategory = filteredCategories.find(c => c.gender === 0);
    const firstFemaleCategory = filteredCategories.find(c => c.gender === 1);
    
    // Prefer male category if exists, otherwise female
    const firstCategory = firstMaleCategory || firstFemaleCategory;
    
    if (firstCategory) {
      setSelectedCategoryId(firstCategory.saloncategoryId);
      setActiveGenderTab(firstCategory.gender === 0 ? "male" : "female");
    } else {
      setSelectedCategoryId(null);
      setCategoryServices([]);
    }
  };



  const columns = (navigate) => [
    {
      title: "S No.",
      dataIndex: "id",
      key: "id",
      width: "60px",
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },
    {
      title: "Service Name",
      dataIndex: "serviceName",
      key: "serviceName",
      width: "200px",
    },

    {
      title: "Duration",
      dataIndex: "serviceTime",
      key: "serviceTime",
      width: "200px",
    },

    {
      title: "Descripton",
      dataIndex: "description",
      key: "description",
      width: "300px",
    },
    {
      title: "Actual Price",
      dataIndex: "actualPrice",
      key: "actualPrice",
      width: "200px",
    },
    {
      title: "Selling Price",
      dataIndex: "sellingPrice",
      key: "sellingPrice",
      width: "200px",
    },

    {
      title: "Service Time",
      dataIndex: "serviceTime",
      key: "serviceTime",
      // width: 200,
    },

    {
      title: "Status",
      dataIndex: "status",
      width: 120,
      align: "center",
      render: (is_active, item) => (
        <Switch
          checked={is_active === 1}
          checkedChildren="Approved"
          unCheckedChildren="Rejected"
          // onChange={(checked) => handleStatusChange(checked, item)}
        />
      ),
    },
  ];

  const handleCategoryChange = (saloncategoryId) => {
    setSelectedCategoryId(saloncategoryId); // Update selected category
  };

  const handleTabChange = (key) => {
    const selectedCategory = salonCategories.filter(
      (category) => category.categoryId === parseInt(key)
    );
    setCategoryServices(
      selectedCategory.length > 0 ? selectedCategory[0].services : []
    );
  };

  const handleGenderTabChange = (genderKey) => {
    setActiveGenderTab(genderKey);
    
    const filteredCategories = salonCategories.filter((category) => {
      if (activeVisitType === "home") return category.visitType === 0;
      if (activeVisitType === "salon") return category.visitType === 1;
      return category.visitType === 2;
    });

    // Find first category for the selected gender
    const firstCategory = filteredCategories.find(c => 
      (genderKey === "male" && c.gender === 0) || 
      (genderKey === "female" && c.gender === 1)
    );

    if (firstCategory) {
      setSelectedCategoryId(firstCategory.saloncategoryId);
    }
  };
  useEffect(() => {
    const fetchSalonCategory = () => {
      setLoading(true);
      SalonRequest.salonCategory(salonId)
        .then((response) => {
          const salonCategoryData = response?.data?.data || [];
          setSalonCategories(salonCategoryData);

          if (salonCategoryData.length > 0) {
            // Set initial state - first male home visit category
            const firstMaleHome = salonCategoryData.find(c => 
              c.visitType === 0 && c.gender === 0
            ) || salonCategoryData[0];
            
            if (firstMaleHome) {
              setSelectedCategoryId(firstMaleHome.saloncategoryId);
              setActiveVisitType(
                firstMaleHome.visitType === 0 ? "home" : 
                firstMaleHome.visitType === 1 ? "salon" : "both"
              );
              setActiveGenderTab(firstMaleHome.gender === 0 ? "male" : "female");
            }
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    };
    if (salonId) fetchSalonCategory();
  }, [salonId]);

  // fetching category services

  // useEffect(() => {
  //   const fetchSalonCategoryService = () => {
  //     if (!selectedCategoryId && salonCategories.length > 0) {
  //       const firstCategoryId = salonCategories[0].saloncategoryId;
  //       setSelectedCategoryId(firstCategoryId);
  //       return;
  //     }
  //     if (!selectedCategoryId) return;
  //     setLoading(true);

  //     SalonRequest.salonCategoryServices(selectedCategoryId)
  //       .then((response) => {
  //         const salonCategoryServicesData = response?.data?.data || [];
  //         console.log("salonCategoryServicesData", salonCategoryServicesData);

  //         // Flatten the nested services array
  //         // const allServices = salonCategoryServicesData.flatMap(
  //         //   (category) => category.salonServiceBycategoryId || []
  //         // );
          

  //         setCategoryServices(salonCategoryServicesData);
  //         // console.log("categoryServices" , categoryServices)
  //       })
  //       .catch((error) => {
  //         // message.error("Failed to fetch salon category services");
  //         console.error("Error:", error);
  //       })
  //       .finally(() => {
  //         setLoading(false);
  //       });
  //   };

  //   fetchSalonCategoryService();
  // }, [selectedCategoryId]);

   // Fetch category services when selectedCategoryId changes

  useEffect(() => {
    const fetchSalonCategoryService = () => {
      if (!selectedCategoryId) return;
      setLoading(true);

      SalonRequest.salonCategoryServices(selectedCategoryId)
        .then((response) => {
          const salonCategoryServicesData = response?.data?.data || [];
          setCategoryServices(salonCategoryServicesData);
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    };

    fetchSalonCategoryService();
  }, [selectedCategoryId]);

 const renderGenderTabs = (filteredCategories) => (
    <Tabs 
      activeKey={activeGenderTab}
      onChange={handleGenderTabChange}
    >
      <Tabs.TabPane key="male" tab="Male">
        <Tabs
          onChange={handleCategoryChange}
          activeKey={selectedCategoryId?.toString()}
        >
          {filteredCategories
            .filter((category) => category.gender === 0)
            .map((category) => (
              <Tabs.TabPane
                key={category.saloncategoryId}
                tab={category.categoryName}
              >
                <div>
                  <div className="subscription">
                    <Form.Item label="Spots">
                      <span>{category.maxServiceQuantity}</span>
                    </Form.Item>
                  </div>
                  <Table
                    size="middle"
                    bordered
                    rowClassName={getRowClassName}
                    components={components}
                    columns={columns(navigate)}
                    loading={loading}
                    dataSource={categoryServices || []}
                    scroll={{ x: "max-content" }}
                  />
                </div>
              </Tabs.TabPane>
            ))}
        </Tabs>
      </Tabs.TabPane>

      <Tabs.TabPane key="female" tab="Female">
        <Tabs
          onChange={handleCategoryChange}
          activeKey={selectedCategoryId?.toString()}
        >
          {filteredCategories
            .filter((category) => category.gender === 1)
            .map((category) => (
              <Tabs.TabPane
                key={category.saloncategoryId}
                tab={category.categoryName}
              >
                <div>
                  <div className="subscription">
                    <Form.Item label="Spots">
                      <span>{category.maxServiceQuantity}</span>
                    </Form.Item>
                  </div>
                  <Table
                    size="middle"
                    bordered
                    rowClassName={getRowClassName}
                    components={components}
                    columns={columns(navigate)}
                    loading={loading}
                    dataSource={categoryServices || []}
                    scroll={{ x: "max-content" }}
                  />
                </div>
              </Tabs.TabPane>
            ))}
        </Tabs>
      </Tabs.TabPane>
    </Tabs>
  );
  return (
    <>
      <Tabs defaultActiveKey="home" onChange={handleVisitTypeChange}>
        <Tabs.TabPane key="home" tab="Home Visit">
          {renderGenderTabs(
            salonCategories.filter((category) => category.visitType === 0)
          )}
        </Tabs.TabPane>

        <Tabs.TabPane key="salon" tab="Salon Visit">
          {renderGenderTabs(
            salonCategories.filter((category) => category.visitType === 1)
          )}
        </Tabs.TabPane>

        <Tabs.TabPane key="both" tab="Both">
          {renderGenderTabs(
            salonCategories.filter((category) => category.visitType === 2)
          )}
        </Tabs.TabPane>
      </Tabs>
    </>
  );
};

export const Appointment = ({ customerDetails }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [salonAppointment, setSalonAppointment] = useState([]);
  const { salonId } = useParams();

  const columns = (navigate) => [
    {
      title: "S No.",
      dataIndex: "sno",
      key: "sno",
      width: "60px",
      render: (value, item, index) => index + 1,
    },
    {
      title: "Appointment ID",
      dataIndex: "appointmentId",
      key: "appointmentId",
      width: "200px",
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
      width: "200px",
    },
    {
      title: "Slot Details",
      dataIndex: "services",
      key: "services",
      width: "200px",
      render: (services) => {
        if (!services[0]?.slot) {
          return "No appointment date";
        }
        return (
          <div>
            <div style={{ display: "flex", gap: "7px" }}>
              <div>{services[0]?.slot || "N/A"}</div>
            </div>
          </div>
        );
      },
    },
    {
      title: "Date",
      dataIndex: "appointmentDate",
      key: "appointmentDate",
      width: "200px",
      render: (appointmentDate) =>
        appointmentDate ? dayjs(appointmentDate).format("DD-MM-YYYY") : "-",
    },
    // {
    //   title: "Services",
    //   dataIndex: "services",
    //   key: "services",
    //   width: '200px',
    //   render: (services) => {
    //     console.log(services, 'serviceesfsadfds')
    //     if (!services || services.length === 0) {
    //       return "No services"
    //     }
    //     const firstService = services[0];
    //     const remainingCount = services.length - 1;
    //     return remainingCount > 0 ? `${firstService}... +${remainingCount}` : firstService;
    //   }
    // },
    {
      title: "Services",
      dataIndex: "services",
      key: "services",
      width: "200px",
      render: (services) => {
        console.log(services, "serviceesfsadfds");
        if (!services[0]?.serviceName || services.length === 0) {
          return "No services";
        }
        const firstService = services[0]?.serviceName;
        const remainingCount = services.length - 1;
        return remainingCount > 0
          ? `${firstService}... +${remainingCount}`
          : firstService;
      },
    },
    {
      title: "Visit Type",
      dataIndex: "visitType",
      key: "visitType",
      width: "160px",
      render: (services) => {
        console.log(services, "visit");
        if (services === 0) return "Home ";
        if (services === 1) return "Salon ";
        if (services === 2) return "Both";
      },
    },

    {
      title: "Total Price",
      dataIndex: "totalPrice",
      key: "totalPrice",
      width: "160px",
      // render: (value, data) => {
      //   const salon = data?.visitType
      //   if (salon === 0) return "Home ";
      //   if (salon === 1) return "Salon ";
      //   if (salon === 2) return "Both"
      // }
    },
    {
      title: "Discounted Price",
      dataIndex: "discountedPrice",
      key: "discountedPrice",
      width: "160px",
      // render: (value, data) => {
      //   const salon = data?.visitType
      //   if (salon === 0) return "Home ";
      //   if (salon === 1) return "Salon ";
      //   if (salon === 2) return "Both"
      // }
    },

    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   width: 120,
    //   align: "center",
    //   render: (status, item) => (
    //     <Switch
    //       checked={status === 1}
    //       checkedChildren="Approved"
    //       unCheckedChildren="Cancelled"
    //     />
    //   ),
    // },
    {
      title: "Status",
      dataIndex: "status",
      width: 120,
      align: "center",
      render: (status) => (
        
          status === 1 ? (
                  <Tag color="#87d068">Approved</Tag>
                )
        : (
                  <Tag color="#f50">Cancelled</Tag>
                )
      ),
    },

    {
      title: "Action",
      dataIndex: "Action",
      key: "Action",
      width: "200px",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip
            title="View Details"
            style={{ color: "red", cursor: "pointer" }}
          >
            {/* <span className="action-icon-bg" onClick={() => navigate("/appoinments/view")}> */}
            <span
              className="action-icon-bg"
              onClick={() =>
                navigate(`/appoinments/view/${record?.appointmentId}`)
              }
            >
              <img src={IMAGES.ViewIcon} />
            </span>
          </Tooltip>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    const fetchSalonAppointment = () => {
      setLoading(true);
      SalonRequest.salonAppointment(salonId)
        .then((response) => {
          const salonAppointmentData = response?.data?.data || [];
          setSalonAppointment(salonAppointmentData);
        })
        .catch((error) => {
          // message.error("Failed to fetch salon categories");
          console.error("Error:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    };
    if (salonId) fetchSalonAppointment();
  }, [salonId]);

  return (
    <>
      <div>
        <Table
          size="middle"
          bordered
          rowClassName={getRowClassName}
          components={components}
          columns={columns(navigate)}
          loading={loading}
          dataSource={salonAppointment}
        />
      </div>
    </>
  );
};

export const ViewSalon = () => {
  const [viewImg, setViewImg] = useState(null);
  const [highlight, setHighlight] = useState(null);
  const [ImageURl, setImageURl] = useState([]);
  const [loading, setLoading] = useState(false);
  const initialFilter = { page: 1, limit: 10 };
  const [filter, setFilter] = useState(initialFilter);
  const navigate = useNavigate();
  const { salonId } = useParams();
  const [form] = Form.useForm();
  const [salonDetails, setSalonDetails] = useState({});
  const [workingDays, setWorkingDays] = useState([]);
  const [workingHours, setWorkingHours] = useState([]);
  const [selectedDay, setSelectedDay] = useState({ day: 1 });
  console.log(workingDays, "workingdays");
  const location = useLocation();
  const defaultTab = location?.state?.activeTab || "1";
  const [activeTab, setActiveTab] = useState("1");
  const [salonCategories, setSalonCategories] = useState([]);
  const [salonCategoriesServices, setSalonCategoriesServices] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);

  const HandleHighlight = (id, image) => {
    setHighlight(id);
    setViewImg(image);
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    const getSalonDetails = async () => {
      setLoading(true);
      try {
        const res = await SalonRequest.salonDetail(salonId);
        console.log("res", res);
        const salonData = res?.data?.data;

        setSalonDetails(salonData);
        console.log("salon Data", salonData);

        // if (salonData?.images) {
        //   const imageArray = salonData.images.map((imageData) => ({
        //     id: imageData.id,
        //     image: imageData.salonImage,
        //   }));
        // setImageURl(imageArray);

        if (Array.isArray(salonData?.images)) {
          const imageArray = salonData.images.map((imageData) => ({
            id: imageData.id,
            image: imageData.salonImage,
          }));
          setImageURl(imageArray);

          console.log("setImageURl", ImageURl);
          console.log("imageArray", imageArray);
          console.log("image url", ImageURl);

          if (imageArray.length > 0) {
            setViewImg(imageArray[0].image);
            setHighlight(imageArray[0].id);
          }
        }

        // if (res?.data?.data && salonData) {
        //   const parsedWorkingDays = JSON?.parse(salonData?.workingDays) || [];
        //   console.log("workdata", res.data.data.workingDays)
        //   setWorkingDays(parsedWorkingDays);
        //   console.log("workingDays", parsedWorkingDays);
        // }

        // if (res?.data?.data && salonData) {
        //   const parsedWorkingHours = JSON?.parse(salonData?.workingHours) || [];
        //   console.log("workinghours", parsedWorkingHours);
        //   setWorkingHours(parsedWorkingHours);
        // }

        if (salonData?.workingDays) {
        setWorkingDays(salonData.workingDays);
        console.log("workingDays", salonData.workingDays);
      }

      // No need to parse workingHours - it's already an object
      if (salonData?.workingHours) {
        setWorkingHours(salonData.workingHours);
        console.log("workinghours", salonData.workingHours);
      }

      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    };

    if (salonId) getSalonDetails();
  }, [salonId]);

  useEffect(() => {
    console.log("Updated ImageURl:", ImageURl);
  }, [ImageURl]);

  useEffect(() => {
    if (ImageURl.length > 0) {
      setViewImg(ImageURl[0].image);
      setHighlight(ImageURl[0].id);
    }
  }, [ImageURl]);

  console.log("setSalonDetails", setSalonDetails);

  if (!salonDetails) {
    return <div>Loading...</div>;
  }

  const item = [
    {
      key: "1",
      label: "Categories",
      children: <Categories salonCategories={salonCategories} />,
    },
    {
      key: "2",
      label: "Appointment",
      children: <Appointment />,
    },
  ];

  const handleDayClick = (day) => {
    setSelectedDay(day); // Set the selected day
    console.log(day);
  };
  const dayNames = ["Mon", "Tue", "Wed", "Thur", "Fri", "Sat", "Sun"];
  return (
    <>
      <Form.Item className="submit-btn">
        <Space>
          <Button
            className="f-sub-btn btn-width"
            onClick={() => navigate(-1)}
            disabled={loading}
          >
            <ArrowLeftOutlined />
          </Button>
        </Space>
      </Form.Item>
      <div className="mainViewCategories">
        <div className="leftViewCategories">
          <div className="mainImageViewCategories">
            <img
              style={
                highlight && ImageURl.find(({ id }) => id === highlight)
                  ? {}
                  : { width: "140px" } // Apply specific style for the "image not found" case
              }
              src={
                highlight
                  ? ImageURl.find(({ id }) => id === highlight)?.image
                  : IMAGES.imageNotFound
              }
              alt="Salon Main View"
            />
          </div>
          {/* <div className="bottomImageViewCategories"
          style={{ overflowX: ImageURl.length > 7 ? "hidden" : "hidden" }} >
            {ImageURl.map(({ image, id }, index) => (
              <div
                key={id}
                className={`subImageViewCategories ${highlight === id ? "highlight" : ""
                  }`}
                onClick={() => HandleHighlight(id, image)}
              >
                <img
                  className=""
                  src={image}
                  alt={`Sub Image ${index + 1}`}
                  srcset=""
                />
              </div>
            ))}
          </div> */}

          <div
            className="bottomImageViewCategories"
            style={{ overflowX: ImageURl.length > 7 ? "hidden" : "hidden" }}
          >
            {ImageURl.slice(0, 7).map(({ image, id }, index) => (
              <div
                key={id}
                className={`subImageViewCategories ${
                  highlight === id ? "highlight" : ""
                }`}
                onClick={() => HandleHighlight(id, image)}
              >
                <img
                  className=""
                  src={image}
                  alt={`Sub Image ${index + 1}`}
                  // srcSet=""
                />
              </div>
            ))}
          </div>

          {/* <div className="bottomImageViewCategories">
            <Slider {...sliderSettings}>
              {ImageURl.map(({ image, id }, index) => (
                <div
                  key={id}
                  className={`subImageViewCategories ${highlight === id ? "highlight" : ""}`}
                  onClick={() => HandleHighlight(id, image)}
                >
                  <img
                    className=""
                    src={image}
                    alt={`Sub Image ${index + 1}`}
                    srcSet=""
                  />
                </div>
              ))}
            </Slider>
          </div> */}
        </div>
        <div className="rightViewCategories">
          <div className="rightbottomViewCategories">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <div>
                <h2>{salonDetails?.salonName}</h2>
                <p style={{ fontSize: "22px", fontWeight: 600 }}>
                  {salonDetails?.ownerName}
                </p>
              </div>

              {/* <div style={{ marginTop: '2px' }}>
                <Space direction="vertical">
                  <Switch
                    checked={salonDetails?.status === 1}
                    checkedChildren="Active"
                    unCheckedChildren="Inactive"
                  />
                </Space>
              </div> */}

              <div style={{ marginTop: "2px" }}>
                {salonDetails?.status === 1 ? (
                  <Tag color="#87d068">Active</Tag>
                ) : (
                  <Tag color="#f50">Inactive</Tag>
                )}
              </div>

            </div>
            <div
              style={{
                display: "flex",
                gap: "7rem",
                marginTop: "20px",
              }}
            >
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    marginBottom: "2.5rem",
                  }}
                >
                  <MdPhoneAndroid style={{ fontSize: "20px" }} />
                  <span>{salonDetails?.mobile}</span>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    marginTop: "5px",
                  }}
                >
                  <MdEmail style={{ fontSize: "20px" }} />
                  <span>{salonDetails?.email}</span>
                </div>
              </div>
              <div>
                <div style={{ flex: "1" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "6px",
                      marginBottom: "1rem",
                    }}
                  >
                    <FaAddressBook
                      style={{ fontSize: "20px", wordBreak: "break-word" }}
                    />
                    <span>
                      {salonDetails?.address?.address} ,{" "}
                      {salonDetails?.address?.area}{" "}
                      {salonDetails?.address?.city} <br />
                      {salonDetails?.address?.pinCode}{" "}
                      {salonDetails?.address?.state}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      // alignItems: "center",
                      alignItems: "flex-start",
                      gap: "6px",
                      marginTop: "5px",
                    }}
                  >
                    <FaAddressCard style={{ fontSize: "20px" }} />
                    <span>{salonDetails?.salonId}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="rightbottomViewSalon">
            <div style={{ display: "flex", gap: "20px" }}>
              <h6>Salon Types :</h6>
              {/* <h6 className="salonType">{salonDetails?.salonType === 1 ? "Male" : "Female"} */}

              <h6 className="salonType">
                {(() => {
                  if (salonDetails?.salonType === 0) return "Men";
                  if (salonDetails?.salonType === 1) return "Women";
                  if (salonDetails?.salonType === 2) return "Unisex";
                })()}
              </h6>
            </div>

            <div style={{ display: "flex", gap: "20px", marginTop: "10px" }}>
              <h6>Service Km :</h6>
              <h6 className="serviceKm">{salonDetails?.serviceKm} Km</h6>
            </div>

            {/* <div style={{ display: "flex", gap: "20px", marginTop: "10px" }}>
              <h6>Working Days :</h6>

              {workingDays?.map((day, index) => (
                <h6
                  className={`salonType workDay ${
                    selectedDay?.day === day ? "active" : ""
                  }`}
                  key={index}
                  onClick={() => handleDayClick({ day })}
                  style={{
                    cursor: "pointer",
                    fontSize: "15px",
                    backgroundColor:
                      selectedDay?.day === day ? "#b31217" : "transparent",
                    color: selectedDay?.day === day ? "#fff" : "#b31217",
                    padding: "0px 12px 0px 12px",
                    borderRadius: "10px",
                  }}
                >
                  {`${dayNames[day - 1]}`}
                </h6>
              ))}
            </div>

            {workingHours && selectedDay && workingHours[selectedDay.day] && (
              <div style={{ display: "flex", gap: "20px", marginTop: "10px" }}>
                <h6>Working Hours :</h6>

                <h6 className="salonType">
                  {workingHours[selectedDay?.day]?.openingTime} -{" "}
                  {workingHours[selectedDay?.day]?.closingTime}
                </h6>
              </div>
            )} */}

            <div style={{ display: "flex", gap: "20px", marginTop: "10px" }}>
  <h6>Working Days :</h6>
  {workingDays?.map((day, index) => (
    <h6
      className={`salonType workDay ${
        selectedDay?.day === day ? "active" : ""
      }`}
      key={index}
      onClick={() => handleDayClick({ day })}
      style={{
        cursor: "pointer",
        fontSize: "15px",
        backgroundColor:
          selectedDay?.day === day ? "#b31217" : "transparent",
        color: selectedDay?.day === day ? "#fff" : "#b31217",
        padding: "0px 12px 0px 12px",
        borderRadius: "10px",
      }}
    >
      {`${dayNames[day - 1]}`}
    </h6>
  ))}
</div>

{workingHours && selectedDay && workingHours[selectedDay.day] && (
  <div style={{ display: "flex", gap: "20px", marginTop: "10px" }}>
    <h6>Working Hours :</h6>
    <h6 className="salonType">
      {workingHours[selectedDay.day]?.openingTime} -{" "}
      {workingHours[selectedDay.day]?.closingTime}
    </h6>
  </div>
)}
{workingHours && selectedDay && workingHours[selectedDay.day]?.lunchTime && (
  <div style={{ display: "flex", gap: "20px", marginTop: "10px" }}>
    <h6>Lunch Time :</h6>
    <h6 className="salonType">
      {workingHours[selectedDay.day].lunchTime.start} -{" "}
      {workingHours[selectedDay.day].lunchTime.end}
    </h6>
  </div>
)}

          </div>
        </div>
      </div>

      <div
        style={{
          marginTop: "20px",
        }}
      >
        {/* <Tabs defaultActiveKey={activeTab} items={items} onChange={(key) => setActiveTab(key)} /> */}

        <Tabs activeKey={activeTab} onChange={setActiveTab} items={item} />
      </div>
    </>
  );
};

//   const [viewImg, setViewImg] = useState(null);
//   const [highlight, setHighlight] = useState(null);
//   const [ImageURl, setImageURl] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const initialFilter = { page: 1, limit: 10 };
//   const [filter, setFilter] = useState(initialFilter);
//   const navigate = useNavigate();
//   const { salonId } = useParams();
//   const [form] = Form.useForm();
//   const [salonDetails, setSalonDetails] = useState({});
//   const [workingDays, setWorkingDays] = useState([]);
//   const [workingHours, setWorkingHours] = useState([]);
//   const [selectedDay, setSelectedDay] = useState({ day: 1 });
//   const location = useLocation();
//   const defaultTab = location?.state?.activeTab || "1";
//   const [activeTab, setActiveTab] = useState("1");
//   const [salonCategories, setSalonCategories] = useState([]);
//   const [salonCategoriesServices, setSalonCategoriesServices] = useState([]);
//   const [totalRecords, setTotalRecords] = useState(0);

//   const sliderSettings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     arrows: true,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//         },
//       },
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//     ],
//   };

//   const HandleHighlight = (id, image) => {
//     setHighlight(id);
//     setViewImg(image);
//   };

//   useEffect(() => {
//     const getSalonDetails = async () => {
//       setLoading(true);
//       try {
//         const res = await SalonRequest.salonDetail(salonId);
//         const salonData = res?.data?.data;
//         setSalonDetails(salonData);

//         if (Array.isArray(salonData?.images)) {
//           const imageArray = salonData.images.map((imageData) => ({
//             id: imageData.id,
//             image: imageData.salonImage,
//           }));
//           setImageURl(imageArray);
//           console.log("ImageURl:", imageArray);
//           if (imageArray.length > 0) {
//             setViewImg(imageArray[0].image);
//             setHighlight(imageArray[0].id);
//           }
//         }

//         if (res?.data?.data && salonData) {
//           const parsedWorkingDays = JSON?.parse(salonData?.workingDays) || [];
//           setWorkingDays(parsedWorkingDays);
//         }

//         if (res?.data?.data && salonData) {
//           const parsedWorkingHours = JSON?.parse(salonData?.workingHours) || [];
//           setWorkingHours(parsedWorkingHours);
//         }
//       } catch (e) {
//         console.log(e);
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (salonId) getSalonDetails();
//   }, [salonId]);

//   if (!salonDetails) {
//     return <div>Loading...</div>;
//   }

//   const item = [
//     {
//       key: "1",
//       label: "Categories",
//       children: <Categories salonCategories={salonCategories} />,
//     },
//     {
//       key: "2",
//       label: "Appointment",
//       children: <Appointment />,
//     },
//   ];

//   const handleDayClick = (day) => {
//     setSelectedDay(day);
//   };

//   const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];

//   return (
//     <>
//       <Form.Item className="text-center submit-btn">
//         <Space>
//           <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}>
//             <ArrowLeftOutlined />
//           </Button>
//         </Space>
//       </Form.Item>
//       <div className="mainViewCategories">
//         <div className="leftViewCategories">
//           <div className="mainImageViewCategories">
//             <img
//               style={
//                 highlight && ImageURl.find(({ id }) => id === highlight)
//                   ? {}
//                   : { width: "140px" }
//               }
//               src={
//                 highlight
//                   ? ImageURl.find(({ id }) => id === highlight)?.image
//                   : IMAGES.imageNotFound
//               }
//               alt="Salon Main View"
//             />
//           </div>
//           <div className="bottomImageViewCategories">
//             <Slider {...sliderSettings}>
//               {ImageURl.map(({ image, id }, index) => (
//                 <div
//                   key={id}
//                   className={`subImageViewCategories ${highlight === id ? "highlight" : ""}`}
//                   onClick={() => HandleHighlight(id, image)}
//                 >
//                   <img
//                     className=""
//                     src={image}
//                     alt={`Sub Image ${index + 1}`}
//                     srcSet=""
//                   />
//                 </div>
//               ))}
//             </Slider>
//           </div>
//         </div>
//         <div className="rightViewCategories">
//           <div className="rightbottomViewCategories">
//             <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
//               <div>
//                 <h2>{salonDetails?.salonName}</h2>
//                 <p style={{ fontSize: "22px", fontWeight: 600 }}>{salonDetails?.ownerName}</p>
//               </div>
//               <div style={{ marginTop: "2px" }}>
//                 <Space direction="vertical">
//                   <Switch
//                     checked={salonDetails?.status === 1}
//                     checkedChildren="Active"
//                     unCheckedChildren="Inactive"
//                   />
//                 </Space>
//               </div>
//             </div>
//             <div style={{ display: "flex", gap: "7rem", marginTop: "20px" }}>
//               <div>
//                 <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "2.5rem" }}>
//                   <MdPhoneAndroid style={{ fontSize: "20px" }} />
//                   <span>{salonDetails?.mobile}</span>
//                 </div>
//                 <div style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "5px" }}>
//                   <MdEmail style={{ fontSize: "20px" }} />
//                   <span>{salonDetails?.email}</span>
//                 </div>
//               </div>
//               <div>
//                 <div style={{ flex: "1" }}>
//                   <div style={{ display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "1rem" }}>
//                     <FaAddressBook style={{ fontSize: "20px", wordBreak: "break-word" }} />
//                     <span>
//                       {salonDetails?.address?.address} , {salonDetails?.address?.area} {salonDetails?.address?.city} <br />
//                       {salonDetails?.address?.pinCode} {salonDetails?.address?.state}
//                     </span>
//                   </div>
//                   <div style={{ display: "flex", alignItems: "flex-start", gap: "6px", marginTop: "5px" }}>
//                     <FaAddressCard style={{ fontSize: "20px" }} />
//                     <span>{salonDetails?.salonId}</span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="rightbottomViewSalon">
//             <div style={{ display: "flex", gap: "20px" }}>
//               <h6>Salon Types :</h6>
//               <h6 className="salonType">
//                 {(() => {
//                   if (salonDetails?.salonType === 0) return "Men";
//                   if (salonDetails?.salonType === 1) return "Women";
//                   if (salonDetails?.salonType === 2) return "Unisex";
//                 })()}
//               </h6>
//             </div>
//             <div style={{ display: "flex", gap: "20px", marginTop: "10px" }}>
//               <h6>Service Km :</h6>
//               <h6 className="serviceKm">{salonDetails?.serviceKm} Km</h6>
//             </div>
//             <div style={{ display: "flex", gap: "20px", marginTop: "10px" }}>
//               <h6>Working Days :</h6>
//               {workingDays?.map((day, index) => (
//                 <h6
//                   className={`salonType workDay ${selectedDay?.day === day ? "active" : ""}`}
//                   key={index}
//                   onClick={() => handleDayClick({ day })}
//                   style={{
//                     cursor: "pointer",
//                     fontSize: "15px",
//                     backgroundColor: selectedDay?.day === day ? "#b31217" : "transparent",
//                     color: selectedDay?.day === day ? "#fff" : "#b31217",
//                     padding: "0px 12px 0px 12px",
//                     borderRadius: "10px",
//                   }}
//                 >
//                   {`${dayNames[day - 1]}`}
//                 </h6>
//               ))}
//             </div>
//             {workingHours && selectedDay && workingHours[selectedDay.day] && (
//               <div style={{ display: "flex", gap: "20px", marginTop: "10px" }}>
//                 <h6>Working Hours :</h6>
//                 <h6 className="salonType">
//                   {workingHours[selectedDay?.day]?.openingTime} - {workingHours[selectedDay?.day]?.closingTime}
//                 </h6>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//       <div style={{ marginTop: "20px" }}>
//         <Tabs activeKey={activeTab} onChange={setActiveTab} items={item} />
//       </div>
//     </>
//   );
// };
